export function getHoursData(intl) {
  const selectOptions = [];
  for (let index = 1; index <= 24; index++) {
    let textHours = intl.formatMessage({ id: 'controlpanel.global.hours' });
    if (index === 1) {
      textHours = intl.formatMessage({ id: 'controlpanel.global.hour' });
    }
    selectOptions.push({ value: index, label: `${index} ${textHours}` });
  }

  return selectOptions;
}
